import {
  Button,
  tokens,
  Typography,
  Pill,
} from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";

type SiteModelPriorityOptionProps = {
  onClick?: () => void;
  title: string;
  priority: number;
  status?: React.ReactNode;
  recommended?: boolean;
  description?: string[];
};

const SiteModelPriorityOption = ({
  title,
  priority,
  onClick,
  status,
  recommended,
  description,
}: SiteModelPriorityOptionProps) => {
  return (
    <Container onClick={onClick}>
      <Header>
        <Title className="priority-title">{title}</Title>
        {recommended && (
          <StyledPill text="Recommended" type="success" hideIcon={true} />
        )}
      </Header>
      <Typography>
        <Priority>~{priority}</Priority>
        mins processing time
      </Typography>
      <DescriptionList>
        {description?.map((item, index) => (
          <li key={index}>
            <Typography>{item}</Typography>
          </li>
        ))}
      </DescriptionList>

      <ActionContainer>
        {onClick && <Button onClick={onClick}>Request</Button>}
        {status}
      </ActionContainer>
    </Container>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 48px;
`;

const Title = styled(Typography)`
  &.priority-title {
    font-size: 18px;
    font-weight: 600;
    line-height: 32px;
  }
`;

const StyledPill = styled(Pill)`
  max-width: fit-content;
  padding: 4px 32px !important;
`;

const Container = styled.div`
  padding: 16px;
  border-radius: 24px;
  border: 1px solid ${tokens.TINTS_HERO_BLUE_70};
  background: ${tokens.WHITE};
  display: flex;
  flex-direction: column;
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
`;

const Priority = styled.span`
  font-size: 38px;
  font-weight: 600;
  line-height: 48px;
  margin-right: 8px;
`;

const DescriptionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export { SiteModelPriorityOption };
